import { ComponentsPreview, useComponentsPreview } from './ComponentsPreview';
import { Column } from './DesignSystem';
import { Palette } from './Palette';

const EnableComponentsPalette = false;
export function ComponentsPalette() {
  const { state } = useComponentsPreview();

  if (!EnableComponentsPalette) {
    return <></>;
  }

  return (
    <Palette windowID="components" title="Components">
      <Column>
        {state.functionIDOrdering.map((id) => {
          const fn = state.functionComponentsByID[id];
          if (fn === undefined) {
            return <></>;
          }

          return (
            <div key={fn.id} style={{ marginBlockEnd: 8 }}>
              <ComponentsPreview component={fn} />
            </div>
          );
        })}
      </Column>
    </Palette>
  );
}
